import React, { PropsWithChildren, useEffect, useState } from 'react';
import { IntlProvider as ReactIntlProvider } from 'react-intl';
import { useBpIntlProviderContext } from './BpIntlProviderContextProvider';

export interface BpIntlProviderImplProps {
  messages: Record<string, string>;
  getMessages?: (key: Exclude<string, 'en'>) => Promise<Record<string, string>>;
}

export function BpIntlProviderImpl({ children, messages, getMessages }: PropsWithChildren<BpIntlProviderImplProps>) {
  const { defaultLang, currentLang } = useBpIntlProviderContext();
  const [defaultMessages] = useState(messages ?? {});
  const [currentNonEnMessages, setCurrentNonEnMessages] = useState<Record<string, string>>({});

  const messagesLoaded = !!Object.keys(defaultMessages).length;

  useEffect(() => {
    if (currentLang !== defaultLang && getMessages) {
      getMessages(currentLang as Exclude<string, 'en'>).then((messages) => {
        setCurrentNonEnMessages(messages);
      });
      return;
    }
  }, [defaultLang, currentLang, getMessages]);

  if (!messagesLoaded) {
    return null;
  }

  const targetMessages =
    currentLang === defaultLang
      ? defaultMessages
      : !!Object.keys(currentNonEnMessages).length
        ? currentNonEnMessages
        : defaultMessages;

  return (
    <ReactIntlProvider locale={currentLang} defaultLocale={defaultLang} messages={targetMessages} textComponent="span">
      {children}
    </ReactIntlProvider>
  );
}
